<template>
  <div>
    <div class="live">
      <div class="inner">
        <div class="current-programs" v-if="currentLives.length > 0">
          <p class="title">現在配信中</p>
          <div class="live-programs">
            <LiveProgram10tsuruha
              class="card"
              v-for="(program, idx) in currentLives"
              :key="program.id + idx"
              :program="program"
              :liveType="getLiveType(program)"
              :month="month"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="timeschedule">
      <p class="title">タイムスケジュール</p>
      <div class="tab">
        <span class="tab-content" :class="{'change': $store.state.lastSelectedContent === 'all' || !$store.state.lastSelectedContent }" @click.prevent="changeTab('all')">すべて</span>
        <span class="tab-content" :class="{'change': $store.state.lastSelectedContent === 'tsuruha' }" @click.prevent="changeTab('tsuruha')">メイン<br>チャンネル</span>
        <span class="tab-content" :class="{'change': $store.state.lastSelectedContent === 'company' }" @click.prevent="changeTab('company')">キーワード<br>付き企業LIVE</span>
        <span class="tab-content" :class="{'change': $store.state.lastSelectedContent === 'provider' }" @click.prevent="changeTab('provider')">ママ<br>チャンネル</span>
      </div>
      <TimeLine
        :timeline="timeline"
      />
    </div>
    <div slot="spinner" v-if="!loaded">
      <Spinner />
    </div>
    <template v-if="selectTime === 'すべて'">
      <!-- 全て＋全ての時 -->
      <template>
        <div class="live live01">
          <div class="inner">
            <template v-if="$store.state.lastSelectedContent === 'tsuruha'">
              <Title>
                <template #title>
                  メインチャンネル
                </template>
              </Title>
              <div class="description">
                <p>
                  スペシャルゲストとしてよしお兄さんが登場！親子で楽しめる歌やダンスのステージのほか、ツルハドラッグから暮らしのヒントになる情報をお届けします。
                </p>
              </div>
            </template>
            <template v-else-if="$store.state.lastSelectedContent === 'company'">
              <Title>
                <template #title>
                  プレゼントキーワード付き企業LIVE
                </template>
              </Title>
              <div class="description">
                <p>美と健康をテーマに子育て応援企業やメーカーが約40社集合！配信中に発表されるキーワードを５つ集めて抽選会に応募しよう！<br><font color="red">※プレゼント抽選会は終了しました。</font></p>
              </div>
            </template>
            <template v-else-if="$store.state.lastSelectedContent === 'provider'">
              <Title>
                <template #title>
                  ママチャンネル
                </template>
              </Title>
              <div class="description">
                <p>
                  オンライン交流会や育児セミナー、ワークショップ体験など、東京・仙台・北海道のママ主催者による楽しいコンテンツが盛りだくさん♪
                </p>
              </div>
            </template>
            <div class="live-programs">
              <template v-for="(frame, key) in displayDeliveryFrames">
                <div class="time" :key="`time-${key}`" v-show="selectTime === 'すべて' && loaded && allLives(frame).length > 0 ">
                  <div class="line">{{ displayDeliveryFrameTable[frame] }}</div>
                  <div class="circle"></div>
                </div>
                <div class="verticalline" :key="key+frame" v-show="selectTime === 'すべて' && loaded && allLives(frame).length > 0">
                  <LiveProgram10tsuruha
                    class="card"
                    v-for="(program, idx) in allLives(frame)"
                    :key="program.id + idx"
                    :program="program"
                    :liveType="getLiveType(program)"
                    :month="month"
                  />
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <!-- 時間で絞り込まれている。ここは8月までのLive.vueを当てはめる。 -->
      <Live03 v-if="($store.state.lastSelectedContent === 'all' ||  $store.state.lastSelectedContent === 'tsuruha') && getEachTimeLive('tsuruha').length > 0" :contents="getEachTimeLive('tsuruha')" :month="month"/>
      <Live01 v-if="($store.state.lastSelectedContent === 'all' ||  $store.state.lastSelectedContent === 'company') && getEachTimeLive('company').length > 0" :contents="getEachTimeLive('company')" :month="month"/>
      <Live02 v-if="($store.state.lastSelectedContent === 'all' || $store.state.lastSelectedContent === 'provider') && getEachTimeLive('provider').length > 0" :contents="getEachTimeLive('provider')" :month="month"/>
    </template>
  </div>
</template>


<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import LiveProgram10tsuruha from '@/components/molecules/202010tsuruha/LiveProgram.vue'
import Spinner from '@/components/atoms/Spinner.vue'
import TimeLine from '@/components/molecules/202008/TimeLine.vue'
import _ from 'lodash'
import Live01 from '@/components/organisms/202010tsuruha/Live01.vue'
import Live02 from '@/components/organisms/202010tsuruha/Live02.vue'
import Live03 from '@/components/organisms/202010tsuruha/Live03.vue'
import Title from '@/components/atoms/Title.vue'

export default {
  props: {
    month: {
      type: String,
      required: true
    }
  },
  components: {
    LiveProgram10tsuruha,
    Spinner,
    TimeLine,
    Live01,
    Live02,
    Live03,
    Title
  },
  data: () => ({
    loaded: false,
    table1002: {
      1: '10:00',
      2: '10:10',
      3: '11:00',
      4: '11:50',
      5: '12:40',
      6: '13:30',
      7: '14:20',
      8: '15:10',
      9: '15:50'
    },
    table1003: {
      10: '10:00',
      11: '10:10',
      12: '11:00',
      13: '11:50',
      14: '12:40',
      15: '13:30',
      16: '14:20',
      17: '15:10',
      18: '15:50'
    },
    timeline: [
      'すべて',
      '10:00',
      '10:10',
      '11:00',
      '11:50',
      '12:40',
      '13:30',
      '14:20',
      '15:10',
      '15:50'
    ],
    contentType: '',
    beforeDf: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    afterDf: [10, 11, 12, 13, 14, 15, 16, 17, 18],
    allDf: [1, 2, 3, 4, 5, 6, 7, 8, 10, 11, 12, 13, 14, 15, 16, 17, 18],
    allTable: {
      '2020-10-02 10:00': 1,
      '2020-10-02 10:10': 2,
      '2020-10-02 11:00': 3,
      '2020-10-02 11:50': 4,
      '2020-10-02 12:40': 5,
      '2020-10-02 13:30': 6,
      '2020-10-02 14:20': 7,
      '2020-10-02 15:10': 8,
      '2020-10-02 15:50': 9,
      '2020-10-03 10:00': 10,
      '2020-10-03 10:10': 11,
      '2020-10-03 11:00': 12,
      '2020-10-03 11:50': 13,
      '2020-10-03 12:40': 14,
      '2020-10-03 13:30': 15,
      '2020-10-03 14:20': 16,
      '2020-10-03 15:10': 17,
      '2020-10-03 15:50': 18
    }
  }),
  computed: {
    ...mapState([
      'dateTab',
      'selectTime',
      'lastSelectedDateTab'
    ]),
    ...mapGetters([
      'companyLive0915',
      'providerLive0915'
    ]),
    displayDeliveryFrames () {
      if (this.lastSelectedDateTab === '2020-10-02') {
        return this.beforeDf
      }
      return this.afterDf
    },
    displayDeliveryFrameTable () {
      if (this.lastSelectedDateTab === '2020-10-02') {
        return this.table1002
      }
      return this.table1003
    },
    dateTab () {
      return this.$store.state.dateTab
    },
    deliveryFrameList () {
      const dateTab = this.$store.state.dateTab
      if (dateTab === '2020-10-02') {
        return [1, 2, 3, 4, 5, 6, 7, 8, 9]
      }
      return [10, 11, 12, 13, 14, 15, 16, 17, 18]
    },
    currentLives () {
      const allLives = this.companyLive0915.concat(this.providerLive0915)
      const currentLives = allLives.filter((live) => {
        const isCurrent = live.deliveryFrame.filter((frame) => {
          const start = _.invert(this.allTable)[frame]
          const end = this.$moment(start).add(this.len(live.deliveryTime), 'minutes')
          return this.$moment().isBetween(start, end, 'minute', '[]')
        })
        return isCurrent.length > 0
      })
      return currentLives
    }
  },
  methods: {
    ...mapActions([
      'getTsuruhaCompanyLivePrograms',
      'getTsuruhaProviderLivePrograms'
    ]),
    getLiveType (program) {
      // 企業、ママ、ツルハで分ける
      if (program.exhibitorName && !program.isTsuruhaChannel) {
        return 'company'
      } else if (program.isTsuruhaChannel) {
        return 'tsuruha'
      }
      return 'provider'
    },
    allLives (frame) {
      // console.log(255)
      let allLives
      if (this.$store.state.lastSelectedContent === 'provider') {
        allLives = this.providerLive0915
      } else if (this.$store.state.lastSelectedContent === 'company') {
        allLives = this.companyLive0915.filter((item, index) => {
          return !item.isTsuruhaChannel
        })
      } else if (this.$store.state.lastSelectedContent === 'tsuruha') {
        // 企業からisTsuruha=trueを取得
        allLives = this.companyLive0915.filter((item, index) => {
          return item.isTsuruhaChannel
        })
      } else {
        allLives = this.companyLive0915.concat(this.providerLive0915)
      }
      allLives = allLives.filter((item, index) => {
        if (item.deliveryFrame.includes(frame)) {
          return true
        }
      })
      return allLives
    },
    changeTab (contentType) {
      this.$store.state.lastSelectedContent = contentType
      this.contentType = contentType
    },
    len (deliveryTime) {
      let time = ''
      switch (deliveryTime) {
        case '1':
          time = 10
          break
        case '2':
          time = 15
          break
        case '3':
          time = 20
          break
        case '4':
          time = 25
          break
        case '5':
          time = 30
          break
        case '6':
          time = 40
          break
        case '7':
          time = 60
          break
      }
      return time
    },
    getEachTimeLive (contentType) {
      console.log(310)
      let allLives, invertTable
      if (this.lastSelectedDateTab === '2020-10-02') {
        invertTable = _.invert(this.table1002)
      } else {
        invertTable = _.invert(this.table1003)
      }
      const frame = this.selectTime !=='すべて' ? Number(invertTable[this.selectTime]) : false
      if (this.$store.state.lastSelectedContent === 'provider' || contentType === 'provider') {
        allLives = this.providerLive0915
      } else if (this.$store.state.lastSelectedContent === 'company' || contentType === 'company') {
        allLives = this.companyLive0915.filter((item, index) => {
          return !item.isTsuruhaChannel
        })
      } else if (this.$store.state.lastSelectedContent === 'tsuruha' || contentType === 'tsuruha') {
        allLives = this.companyLive0915.filter((item, index) => {
          return item.isTsuruhaChannel
        })
      } else {
        allLives = this.companyLive0915.concat(this.providerLive0915)
      }
      if (frame !== false) {
        allLives = allLives.filter((item) => {
          if (item.deliveryFrame.includes(frame)) {
            return true
          }
        })
      }
      return allLives
    }
  },
  async mounted () {
    console.log(this.lastSelectedDateTab)
    if (this.companyLive0915.length === 0 || this.providerLive0915.length === 0) {
      await Promise.all([this.getTsuruhaProviderLivePrograms(), this.getTsuruhaCompanyLivePrograms()])
      this.loaded = true
    } else {
      this.loaded = true
    }
  }
}
</script>

<style lang="sass" scoped>
section
  background-color: $lightpink
  padding-top: 15px
  margin-top: 25px
  .live /deep/
    .description
      margin-top: 5px
      p
        line-height: 1.6
        font-size: 1.2rem
    .live-programs
      display: flex
      justify-content: space-between
      flex-wrap: wrap
      .program-wrapper
        width: calc(50% - 10px)
    .comingsoon
      padding: 50px 0
      figure
        display: flex
        flex-direction: column
        justify-content: center
        align-items: center
        img
          width: 40%
        figcaption
          margin-top: 10px
          text-align: center
          line-height: 1.4
          font-size: 2rem
          font-weight: bold
.live01
  padding: 20px 0 25px
.current-programs
  .title
    font-size: 20px
    font-weight: bold
    color: #00AC3D
    margin-left: 10px
.timeschedule
  padding: 10px 0 0 0
  .title
    font-size: 20px
    font-weight: bold
    color: #00AC3D
    margin-bottom: 20px
    margin-left: 10px
    margin-top: 10px
.tab
  text-align: center
  font-size: 15px
  max-width: 600px
  margin: 0 auto 35px auto
  background-color: #fff
  display: flex
.tab-content:not(:last-child)
  border-right: 0
.tab-content
  display: flex
  cursor: pointer
  justify-content: center
  align-items: center
  border: 2px solid #EC83A4
  line-height: initial
  text-decoration: none
  color: #EC83A4
  padding: 10px 0
  font-weight: bold
  width: 35%
  &.change
    background-color: #FCF4F7
    border-bottom: 0
.time
  margin-top: 20px
  font-size: 20px
  font-weight: bold
  color: #EC83A4
  width: 100%
  max-width: 600px
.line
  display: flex
  align-items: center
  justify-content: center
.line:after
  border-top: 4px dotted
  content: ""
  width: 483px
.line:after
  margin-left: 10px
.circle
  display: inline-block
  width: 20px
  height: 20px
  text-align: center
  line-height: 80px
  border-radius: 50%
  border: solid 6px #EC83A4
  margin-top: 10px
  margin-left: -13px
.verticalline
  width: 100%
  max-width: 600px
  border-left: solid 6px #EC83A4
  margin-left: -5px
  margin-top: -5px
  margin-bottom: 25px
  display: flex
  flex-wrap: wrap
  padding-bottom: 10px
.card
  display: flexv
  margin-top: 7px
  margin-right: 0px
  margin-left: 10px
  width: 50%
  box-sizing: border-box
</style>
